// src/config/runtime.ts
// Provides runtime configuration by reading window.__RUNTIME_CONFIG__ first,
// then falling back to build-time import.meta.env and finally to sane defaults.

export type RuntimeConfig = {
  API_URL: string;
  BLACKBAUD_CLIENT_ID: string;
  BLACKBAUD_REDIRECT_URI: string;
  HS_CLIENT_ID: string;
  HS_REDIRECT_URI: string;
};

const w = (typeof window !== 'undefined' ? (window as any) : {}) as any;
const rc = (w && w.__RUNTIME_CONFIG__) || {};

function get(name: keyof RuntimeConfig, envKey: string, def = ""): string {
  // Prefer runtime variable if present, else build-time Vite env, else default
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const val = rc[name] ?? (import.meta as any)?.env?.[envKey] ?? def;
  return typeof val === 'string' ? val : def;
}

export const RUNTIME: RuntimeConfig = {
  API_URL: get("API_URL", "VITE_API_URL", "/api"),
  BLACKBAUD_CLIENT_ID: get("BLACKBAUD_CLIENT_ID", "VITE_BLACKBAUD_CLIENT_ID", ""),
  BLACKBAUD_REDIRECT_URI: get("BLACKBAUD_REDIRECT_URI", "VITE_BLACKBAUD_REDIRECT_URI", ""),
  HS_CLIENT_ID: get("HS_CLIENT_ID", "VITE_HS_CLIENT_ID", ""),
  HS_REDIRECT_URI: get("HS_REDIRECT_URI", "VITE_HS_REDIRECT_URI", ""),
};